// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__2P8xk","cardFooter":"style_cardFooter__1DN4P","cardHeader":"style_cardHeader__3Fsh2","cardBody":"style_cardBody__2CAv3","cardCover":"style_cardCover__2Skbs"};